import { render, staticRenderFns } from "./invoiceApproval.vue?vue&type=template&id=1a8be64e&scoped=true&"
import script from "./invoiceApproval.vue?vue&type=script&lang=js&"
export * from "./invoiceApproval.vue?vue&type=script&lang=js&"
import style0 from "./invoiceApproval.vue?vue&type=style&index=0&id=1a8be64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8be64e",
  null
  
)

export default component.exports